export const Feature = ({ icon, title, desc }: { icon: string; title: string; desc: string }) => (
    <div className="feature-card">
      <div className="icon">{icon}</div>
      <h3>{title}</h3>
      <p>{desc}</p>
    </div>
  );